import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  createPaymentIntent,
  doCheckOut,
  createWalletPaymentIntent,
  userMetaDetails,
} from "../checkout-c/actions";
import { createHMAC } from "./actions";

import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";

import { getAssessmentAttemptByUserId } from "../dashboard/actions";
import Checkout from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createPaymentIntentConnect: createPaymentIntent,
      doCheckOutConnect: doCheckOut,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      createWalletPaymentIntentConnect: createWalletPaymentIntent,
      userMetaConnect: userMetaDetails,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      createHMACConnect: createHMAC,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
